import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import _PropTypes from 'prop-types';
import * as React from 'react';
import styled from 'styled-components';
import { spacing4x } from '../../styles/spacing.js';
import { useAccordionContext } from '../AccordionContext/AccordionContext.js';
import { useAccordionItemContext } from '../AccordionItemContext/AccordionItemContext.js';
import { IconArrowDown } from '../Icons/IconArrowDown.js';
import { IconArrowUp } from '../Icons/IconArrowUp.js';
import { jsx, jsxs } from 'react/jsx-runtime';

var _excluded = ["ariaLevel", "children"];
var StyledButton = styled.button.withConfig({
  displayName: "AccordionHeader__StyledButton",
  componentId: "th9hpo-0"
})(function (_ref) {
  var theme = _ref.theme;
  return {
    alignItems: "center",
    display: "flex",
    background: "white",
    border: "2px solid transparent",
    color: theme.neutralColors.charcoal,
    justifyContent: "space-between",
    padding: spacing4x,
    width: "318px",
    ":hover": {
      background: theme.neutralColors.pearl
    },
    ":focus": {
      border: "2px solid ".concat(theme.alertColors.information)
    }
  };
});
var StyledHeader = styled.div.withConfig({
  displayName: "AccordionHeader__StyledHeader",
  componentId: "th9hpo-1"
})(["&&{font-weight:bold;font-size:20px;line-height:28px;}"]);

var AccordionHeader = function AccordionHeader(props) {
  var _props$ariaLevel = props.ariaLevel,
      ariaLevel = _props$ariaLevel === void 0 ? 3 : _props$ariaLevel,
      children = props.children,
      rest = _objectWithoutProperties(props, _excluded);

  var _useAccordionItemCont = useAccordionItemContext(),
      focused = _useAccordionItemCont.focused,
      headerId = _useAccordionItemCont.headerId,
      index = _useAccordionItemCont.index,
      onHeaderEvent = _useAccordionItemCont.onHeaderEvent,
      open = _useAccordionItemCont.open,
      panelId = _useAccordionItemCont.panelId;

  var _useAccordionContext = useAccordionContext(),
      onSelect = _useAccordionContext.onSelect;

  var Icon = open ? IconArrowUp : IconArrowDown;

  function handleOnClick(e) {
    e.preventDefault();
    onSelect(index);
  }

  function handleEvent(e) {
    onHeaderEvent(e, index);
  }

  var ref = React.useRef(null);
  React.useEffect(function () {
    if (focused) {
      var _ref$current;

      ref === null || ref === void 0 ? void 0 : (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.focus();
    }
  }, [focused]);
  return /*#__PURE__*/jsx(StyledHeader, {
    role: "heading",
    "aria-level": ariaLevel,
    children: /*#__PURE__*/jsxs(StyledButton, _objectSpread(_objectSpread({
      "aria-controls": panelId,
      "aria-expanded": !!open,
      id: headerId,
      onClick: handleOnClick,
      onFocus: handleEvent,
      onKeyDown: handleEvent,
      type: "button",
      ref: ref
    }, rest), {}, {
      children: [children, /*#__PURE__*/jsx(Icon, {
        focusable: true
      })]
    }))
  });
};

AccordionHeader.propTypes = {
  "ariaLevel": _PropTypes.number,
  "children": _PropTypes.node
};
AccordionHeader.displayName = "AccordionHeader";

export { AccordionHeader };
